import { HttpErrorResponse } from '@angular/common/http';
import {Component, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import {RecaptchaComponent} from "ng-recaptcha";
import {ConsultarDocumentoService} from "./service/consultar-documento.service";

@Component({
  selector: 'autenticador',
  templateUrl: './autenticador.component.html',
  styleUrls: ['./autenticador.component.css']
})
export class AutenticadorComponent implements OnInit {

  numeroProtocolo: string | undefined = undefined;
  dataAssinatura: Date | undefined = undefined;
  token: string | undefined = undefined;
  carregando = false;
  @ViewChild(RecaptchaComponent) captchaRef: RecaptchaComponent | undefined
  constructor(
    private route: ActivatedRoute,
    private consultarService: ConsultarDocumentoService,
    private _snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit() {
    this.numeroProtocolo = this.route.snapshot.queryParams['numeroProtocolo'];
    this.dataAssinatura = this.route.snapshot.queryParams["dataAssinatura"];
  }

  filterNonNumeric(input: string | undefined): string {
    if (input) {
      return input.replace(/\D/g, '');
    }
    return "";
  }

  enviar(formulario: NgForm) {
    this.carregando = true;
    console.log(this.dataAssinatura)
    this.consultarService.consulta(String(this.filterNonNumeric(this.numeroProtocolo)), String(this.dataAssinatura), String(this.token))
      .subscribe({
        next: (value) => {
          const fileUrl = URL.createObjectURL(value);
          window.open(fileUrl, '_blank');
          formulario.resetForm();
          this.carregando = false;
          this.router.navigateByUrl("");
          this.captchaRef?.reset();
        },
        error: (err: HttpErrorResponse) => {
          this.carregando = false;
          const textoErro: Blob = err.error;
          this.captchaRef?.reset();
          if (textoErro.type === 'text/html') {
            this._snackBar.open("Ocorreu um erro interno.", "Fechar", { duration: 10000, panelClass: ['app-snackbar'], });

          } else {
            textoErro.text().then(msgErro => this._snackBar.open(JSON.parse(msgErro).message, "Fechar", { duration: 10000, panelClass: ['app-snackbar'], }));
          }
        },
      });
  }
}
